export enum NaRenewablesHeatMapCellRenderType {
  HOUR = 'hour',
  DAY = 'day',
}
